import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { TranslateModule } from '@ngx-translate/core';

import { EllipsisTooltipTextComponent } from './ellipsis-tooltip-text.component';
import { FcpTooltipModule } from 'fc-ui-components';

@NgModule({
    imports: [CommonModule, TranslateModule, OverlayModule, FcpTooltipModule],
    declarations: [EllipsisTooltipTextComponent],
    exports: [EllipsisTooltipTextComponent]
})
export class EllipsisTooltipTextModule {}
